<template>
    <header class="masthead text-white text-center">
    <div class="overlay"></div>
        <div class="container">
  <div class="row">
    <div class="col-lg-6 order-lg-1 my-auto showcase-text">
        <h4 class="sk-header-sub-text">「バナー作成で手が足りない・・・」</h4>
        <h4 class="sk-header-sub-text">「短納期大量発注・・・」</h4>
          <h2>お困りの制作担当さんを<br>全国のクリエイターが<br>お手伝いします</h2>
           <form>
            <div class="form-row">
              <!-- <div class="col-6 col-md-9 mb-2 mb-md-0">
                <input type="email" class="form-control form-control-lg" placeholder="Enter your email...">
              </div> -->
              <div class="container" >
        <a class="navbar-brand btn sk-btn-color" href="/Register">無料会員登録</a>
    </div>
            </div>
          </form>
        </div>
  </div>
</div>

    <!-- <div class="container">
      <div class="row">
        <div class="col-xl-6 mx-auto">
          <h1 class="col-xl-6 mb-5">Build a landing page for your business or project and generate more leads!</h1>
        </div>
        <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
          <form>
            <div class="form-row">
              <div class="col-6 col-md-9 mb-2 mb-md-0">
                <input type="email" class="form-control form-control-lg" placeholder="Enter your email...">
              </div>
              <div class="col-6 col-md-3">
                <button type="submit" class="btn btn-block btn-lg btn-primary">Sign up!</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div> -->
  </header>
</template>

<script>
export default {
}
</script>

<style>
a.sk-btn-color {
    background-color: #f25458;
    color: #ffffff;
    border-radius: 30px;
}


</style>